<template>
  <div>장치 추가</div>
</template>

<script setup></script>
